<script>
import generateURL from '../../utils/generateURL'
import { getRange } from '../../utils/biomarker'
import { convert } from '../../utils/labReport'

export default {
  name: 'LabReportItem',
  props: {
    biomarkers: {
      default: () => [],
      type: Array,
      required: false
    },
    item: {
      default: () => {},
      type: Object,
      required: false
    },
    index: {
      default: () => 0,
      type: Number,
      required: false
    }
  },
  data() {
    return {
      searchedBiomarker: ''
    }
  },
  computed: {
    getInputType() {
      const { type } = this.item.range
      const isNumber = type === 'universal' || type === 'gender'

      return isNumber ? 'quantity' : 'text'
    },
    getReferenceInterval() {
      if (!this.item || !this.item.unit || this.getInputType === 'text') {
        return null
      }

      const { units } = this.item
      const unit = _.isString(this.item.unit)
        ? this.item.unit
        : this.item.unit.unit
      const { normal } = getRange(this.item, true)
      const [min, max] = normal.map(quantity =>
        convert({ quantity, unit, units, toBase: true, precision: 1 })
      )

      return `${min}–${max}`
    },
    getSearchedBiomarkers() {
      const search = this.searchedBiomarker.toLowerCase()

      const filterByNameAndSynonyms = ({ name, synonyms }) =>
        _.some([name, ...synonyms], x => _.includes(x.toLowerCase(), search))

      const sortByNameDesc = (a, b) => (a.name > b.name ? 1 : -1)

      return this.biomarkers
        .filter(filterByNameAndSynonyms)
        .sort(sortByNameDesc)
    }
    // quantity: {
    // // Convert quantity on change
    //   get() {
    //     const { quantity, unit, units } = this.item
    //     return convert({ quantity, unit, units })
    //   },
    //   set(quantity) {
    //     const { unit, units } = this.item
    //     this.item.quantity = convert({
    //       quantity,
    //       unit,
    //       units,
    //       toBase: true,
    //       precision: false
    //     })
    //   }
    // }
  },
  watch: {
    // // Convert quantity on unit change
    // item: {
    //   handler: function(newItem, oldItem) {
    //     if (newItem.unit === oldItem.unit) return
    //     const { quantity, units } = oldItem
    //     this.item.quantity = convert({
    //       quantity,
    //       unit,
    //       units,
    //       precision: false
    //     })
    //   },
    //   deep: true
    // }
  },
  mounted() {
    if (this.item) {
      this.searchedBiomarker = this.item.name

      try {
        if (this.item.unit.unit) {
          this.item.unit = this.item.units[0].unit
        }
      } catch (ignore) {
        console.log(ignore)
      }
    }
    this.$nextTick(function() {
      const ref = this.$refs.inputQuantity
      if (ref) ref.focus()
    })
  },
  methods: {
    selectBiomarker(option) {
      if (option) {
        this.$emit('updateBiomarker', this.item, option)
      }
    },
    removeItem() {
      this.$emit('updateBiomarker', this.item)
    },
    generateURL
  }
}
</script>

<template>
  <div class="container add-lab-report-item">
    <!-- ToDo: polish design -->

    <!-- Biomarker Item -->
    <div v-if="item" class="biomarker-item">
      <div class="field is-grouped is-grouped-multiline">
        <div class="field has-addons is-expanded">
          <div class="control is-expanded">
            <b-autocomplete
              ref="inputBiomarker"
              v-model="searchedBiomarker"
              class="biomarker-input"
              :data="getSearchedBiomarkers"
              placeholder="e.g. Vitamin B12"
              :clearable="false"
              :tabindex="2 + index * 3"
              field="name"
              @select="selectBiomarker"
            >
              <template slot-scope="props">
                <span
                  :class="[
                    'tag',
                    { 'is-accent': props.option.type == 'BLOOD' },
                    { 'is-warning': props.option.type == 'URINE' },
                    { 'is-info': props.option.type == 'SALIVA' },
                    { 'is-secondary': props.option.type == 'OTHER' }
                  ]"
                  >{{ props.option.type }}</span
                >
                &nbsp;
                {{ props.option.name }}
              </template>
              <template slot="empty">No results found</template>
            </b-autocomplete>
          </div>
          <div class="control">
            <router-link
              tag="a"
              class="button has-text-tertiary"
              :to="{
                name: 'BiomarkerView',
                params: { id: generateURL(item) }
              }"
              target="_blank"
            >
              <span class="icon is-small">
                <i class="fas fa-info-circle" />
              </span>
            </router-link>
          </div>
        </div>
        <div class="field has-addons">
          <div v-if="getInputType === 'quantity'" class="control">
            <b-input
              ref="inputQuantity"
              v-model="item.quantity"
              placeholder="Result"
              :tabindex="2 + index * 3 + 1"
            />
            <p v-if="getReferenceInterval" class="help">
              <span class="has-text-tertiary">Normal range:&nbsp;</span>
              <span class="has-text-success">{{ getReferenceInterval }}</span>
            </p>
          </div>
          <div v-if="getInputType === 'text'" class="control">
            <b-input
              ref="inputQuantity"
              v-model="item.text"
              placeholder="Result"
              :tabindex="2 + index * 3 + 1"
            />
            <p v-if="getReferenceInterval" class="help">
              <span class="has-text-tertiary">Normal range:&nbsp;</span>
              <span class="has-text-success">{{ getReferenceInterval }}</span>
            </p>
          </div>
          <div v-if="item.units.length" class="control">
            <b-select
              ref="inputUnit"
              v-model="item.unit"
              placeholder="Unit"
              :tabindex="2 + index * 3 + 2"
            >
              <option
                v-for="option in item.units"
                :key="option.unit"
                :value="option.unit"
                >{{ option.unit }}</option
              >
            </b-select>
          </div>
        </div>
        <span
          class="button is-white has-text-secondary is-rounded is-small is-pulled-right"
          style="height:2.1rem;width:2.1rem"
          @click="removeItem"
        >
          <span class="icon is-small">
            <i class="fas fa-trash-alt" />
          </span>
        </span>
      </div>
    </div>
    <hr class="spacer" />
    <hr class="spacer is-hidden-tablet" />
  </div>
</template>

<style lang="sass">
.biomarker-input input
  border-top-right-radius: 0 !important
  border-bottom-right-radius: 0 !important
</style>
